import { Chip } from '@mui/material';
import React from 'react';
import { ChipPropsColor, UserStatus } from 'types/common';

interface IUserChipProps {
	status?: UserStatus;
}

const UserChip: React.FC<IUserChipProps> = ({ status }) => {
	let color: ChipPropsColor = 'error';

	switch (status) {
		case UserStatus.enabled:
			color = 'info';
			break;
		case UserStatus.invited:
			color = 'default';
			break;
		case UserStatus.disabled:
			color = 'warning';
			break;
		default:
			color = 'warning';
			break;
	}

	return (
		<Chip
			label={intl.tr(`user.status.${status}`)}
			title={intl.tr(`user.status.${status}`)}
			variant="outlined"
			size="small"
			color={color}
		/>
	);
};

UserChip.defaultProps = {
	status: UserStatus.unknown
};

export default UserChip;
